import React, { useContext, useMemo } from "react";
import { useCollectionData } from "react-firebase-hooks/firestore";
import { collection, query } from "firebase/firestore";
import { db } from "@poseidon/firebase";

const BoatOptionsContext = React.createContext({
  ports: undefined,
  types: undefined,
  models: undefined,
  makes: undefined,
  loading: false,
  error: undefined,
});

export const BoatOptionsProvider = ({ children }) => {
  const [portsData, portsLoading, portsError] = useCollectionData(
    query(collection(db, "portsOfRegistration"))
  );
  const [modelsData, modelsLoading, modelsError] = useCollectionData(
    query(collection(db, "boatModels"))
  );
  const [typesData, typesLoading, typesError] = useCollectionData(
    query(collection(db, "boatTypes"))
  );

  const ports = useMemo(() => {
    return (
      portsData
        ?.map(({ name }) => ({ value: name, label: name }))
        .sort((a, b) => a.label.localeCompare(b.label)) ?? []
    );
  }, [portsData]);

  const types = useMemo(() => {
    return (
      typesData
        ?.map(({ type, title }) => ({ value: type, label: title }))
        .sort((a, b) => a.label.localeCompare(b.label)) ?? []
    );
  }, [typesData]);

  const [makes, models] = useMemo(() => {
    //todo: add sorting
    const makes = modelsData?.reduce((agg, doc) => {
      const key = doc.type;
      const value = doc.make;
      if (agg[key]?.find((option) => option.value === value)) {
        return agg;
      }
      return {
        ...agg,
        [key]: [...(agg[key] ?? []), { value, label: value }],
      };
    }, {});
    //todo: add sorting
    const models = modelsData?.reduce((agg, doc) => {
      return {
        ...agg,
        [doc.type]: {
          ...(agg[doc.type] ?? {}),
          [doc.make]: [
            ...((agg[doc.type] && agg[doc.type][doc.make]) ?? []),
            { value: doc.model, label: doc.model },
          ],
        },
      };
    }, {});

    return [makes, models];
  }, [modelsData]);

  const loading = portsLoading || modelsLoading || typesLoading;
  const error = portsError || modelsError || typesError;

  return (
    <BoatOptionsContext.Provider
      value={{ ports, types, makes, models, loading, error }}
    >
      {children}
    </BoatOptionsContext.Provider>
  );
};

export const usePorts = () => {
  const { ports } = useContext(BoatOptionsContext);
  return ports;
};

export const useBoatMakes = () => {
  const { makes } = useContext(BoatOptionsContext);
  return makes;
};

export const useBoatModels = () => {
  const { models } = useContext(BoatOptionsContext);
  return models;
};
export const useBoatTypes = () => {
  const { types } = useContext(BoatOptionsContext);
  return types;
};
export const useBoatOptions = () => useContext(BoatOptionsContext);
